import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useContext, useState } from "react";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";
import UiContext from "../../../../store/ui-context";

const CheckMenu = (props) => {
  const {
    row,
    onClickFoto,
    pengecekanBerangkatDetilData,
    pengecekanKembaliDetilData,
    isBerangkat,
    onClickEditNote,
    handleOnClickReload,
  } = props;

  const [visible, setVisible] = useState(false);
  const uiContext = useContext(UiContext);
  const { requestPost, loading } = useAPIRequest();

  const { keterangan, showBerangkat, disabled } = row;
  const dataBerangkat = pengecekanBerangkatDetilData.find(
    (el) => el.keterangan === keterangan
  );
  const dataKembali = pengecekanKembaliDetilData.find(
    (el) => el.keterangan === keterangan
  );

  let imageBerangkat = null;
  if (dataBerangkat) {
    imageBerangkat = dataBerangkat.gambar;
  }

  let imageKembali = null;
  if (dataKembali) {
    imageKembali = dataKembali.gambar;
  }

  let data = dataBerangkat;
  if (!isBerangkat) {
    data = dataKembali;

    if (dataKembali.note == null) {
      dataKembali.note = dataBerangkat.note ?? "";
    }
  }

  // const [ note, setNote ] = useState(data ? data.note : '');

  // const handleUpdateNote = () => {
  //   const body = {
  //     id: data.id,
  //     note: note,
  //   };
  //   requestPost({
  //     fullUrl: "/api/pemakaian/pengecekanmobildetil/update",
  //     body,
  //     isForm: false,
  //     onError: ({ message, data }) => {
  //       uiContext.showErrorMsg("Error", message);
  //     },
  //     onSuccess: ({ data, message }) => {
  //       uiContext.showSuccessMsg("Success", message);
  //       handleOnClickReload();
  //       setVisible(false);
  //     },
  //   });
  // }

  return (
    <div className="col-start-start w-full">
      {/* <Dialog header="Change Note" visible={visible} style={{ width: '80vw' }} onHide={() => {if (!visible) return; setVisible(false); }}>
        <div className="row-start-start pt-8 w-full gap-2">
          <InputText 
            className="w-[80%]" 
            value={note ?? ''} 
            onChange={(e) => setNote(e.target.value)} 
            onKeyDown={(e) => {
              if ( e.key === 'Enter' ) {
                handleUpdateNote();
              }
            }}
          />
          <Button
            onClick={handleUpdateNote}
          >
            Save
          </Button>
        </div>
      </Dialog> */}
      <Button
        className="!row-start-center rounded-none bg-white border-none text-slate-500 gap-3 !pl-5 hover:bg-slate-100 w-[10rem]"
        severity="secondary"
        // onClick={() => setVisible(true)}
        onClick={(event) => {
          if (onClickEditNote) onClickEditNote(event, row);
        }}
      >
        <i className="pi pi-pencil text-xs"></i>
        <span>Note</span>
      </Button>
      <Button
        className="!row-start-center rounded-none bg-white border-none text-slate-500 gap-3 !pl-5 pr-4 hover:bg-slate-100 w-full"
        disabled={!isBerangkat}
        onClick={(event) => onClickFoto(event, "berangkat")}
      >
        <i className="pi pi-camera text-xs"></i>
        <span>Berangkat</span>
      </Button>
      <Button
        className="!row-start-center rounded-none bg-white border-none text-slate-500 gap-3 !pl-5 pr-4 hover:bg-slate-100 w-full"
        disabled={isBerangkat}
        onClick={(event) => onClickFoto(event, "kembali")}
      >
        <i className="pi pi-camera text-xs"></i>
        <span>Pulang</span>
      </Button>
    </div>
  );
};

export default CheckMenu;
